import { useSelector } from 'react-redux';
import meStatus from 'store/selectors/meStatus';

/**
 * True once auth company data is safe for feature-gated routing (post-/me, not mid-fetch).
 * Avoids acting on stale redux-persisted featureFlags before the session refresh completes.
 */
export function useCompanyFeaturesReady() {
  const token = useSelector(state => state.auth?.token);
  const me = useSelector(meStatus);

  if (!token?.hash) {
    return true;
  }

  return !me.isUninitialized && !me.isFetching;
}
